<template>
  <div class="video-dialog" v-if="Object.keys(data).length">
    <div class="popup-content">
      <div class="header">
        <span class="title">讨论时间</span>
        <span class="time">{{ data.consultationTime }}</span>
      </div>

      <div class="warper" v-if="data.isInvite">
        <div class="patient">
          <span>受者：</span>
          <div class="patient-text">
            {{ data.patientName }}
            <span>{{ data.patientGender == 1 ? '男' : '女' }}</span>
            {{ data.patientAge }}
          </div>
        </div>
        <div class="doctor">
          <img
            class="left-icon"
            src="@funcPuzzle/remote_collaborative_clinic_app/zuo.png"
            mode=""
          />
          <img
            class="right-icon"
            src="@funcPuzzle/remote_collaborative_clinic_app/you.png"
            mode=""
          />
          <div class="photo">
            <img src="@funcPuzzle/mini_doctor/default-photo.jpg" mode="" />
          </div>
          <div class="name" v-if="data.applyDoctor">
            <span style="font-weight: 500; font-size: 0.853333rem; color: #323843">{{
              data.applyDoctor.doctorName
            }}</span>
            医生
          </div>
          <div class="desc">
            邀请您
            <span style="color: rgba(0, 114, 245, 1)">视频通话</span>
          </div>
        </div>
        <div class="btn">
          <div class="join" @click="join">进入视频</div>
          <div class="cancel" @click="cancel">拒绝</div>
        </div>
      </div>
      <div class="warper" v-if="isSend">
        <div class="patient">
          <span>受者：</span>
          <div class="patient-text">
            {{ data.patientName }}
            <span>{{ data.patientGender == 1 ? '男' : '女' }}</span>
            {{ data.patientAge }}
          </div>
        </div>
        <div class="doctor">
          <img
            class="left-icon"
            src="@funcPuzzle/remote_collaborative_clinic_app/zuo.png"
            mode=""
          />
          <img
            class="right-icon"
            src="@funcPuzzle/remote_collaborative_clinic_app/you.png"
            mode=""
          />
          <div class="photo">
            <img src="@funcPuzzle/mini_doctor/default-photo.jpg" mode="" />
          </div>
          <div class="name">
            正在邀请
            <span style="font-weight: 500; font-size: 0.853333rem; color: #323843">{{
              data.applyDoctor.doctorName
            }}</span>
            医生
          </div>

          <div class="desc">
            <span style="color: rgba(0, 114, 245, 1)">视频通话</span>
          </div>
        </div>
        <div class="btn" style="padding-bottom: 1.109333rem" @click="close">
          <div class="join">取消</div>
        </div>
      </div>
      <div class="warper" v-if="data.isFive">
        <div class="doctor">
          <div class="patient-text">
            {{ data.patientName }}
            <span>{{ data.patientGender == 1 ? '男' : '女' }}</span>
            {{ data.patientAge }}
          </div>

          <div class="desc">
            <span style="color: rgba(0, 114, 245, 1)">5分钟</span>
            后开始
          </div>
        </div>
        <div class="btn" style="margin-bottom: 1.258667rem">
          <div class="join" @click="toJoin">发起视频</div>
          <div class="cancel" @click="toCancel">关闭</div>
        </div>
      </div>
      <!-- 	<img @click="$emit('close')" class="close-icon" src="@funcPuzzle/remote_collaborative_clinic_app/gb.png" mode=""/> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { NativeMessagePush } from '@/utils/nativeBridge/nativeMessage/index.js'
import {
  getMultiPartyConsultationsDetail,
  postInformation,
  directUpdateStatus,
  createMeeting,
  createMeetingRemind,
  noticeEnterMeeting,
  terminal
} from '@/views/funcPuzzle/utils/index.js'
export default {
  name: 'videoDialog',
  mounted() {
    setTimeout(() => {
      this.data = localStorage.getItem('CONSULTATION') || {}
      console.log(this.data, '90-da9d-0a9d-a09d-0a9d-0')
      // console.log(this.isSendDialog)
    }, 0)
  },
  data() {
    return {
      data: localStorage.getItem('CONSULTATION') || {},
      isSend: false
    }
  },
  watch: {
    // data: {
    // 	handler(newVal, oldVal) {
    // 		console.log(`数据从 ${oldVal} 变更为 ${newVal}`);
    // 		this.data = uni.getStorageSync('CONSULTATION') || {}
    // 	},
    // 	deep: true,
    // 	immediate: true
    // }
  },
  computed: {
    ...mapState(['doctor', 'isSendDialog'])
  },
  methods: {
    close() {
      // console.log(this, uni)
      this.socketSend('stop')
      uni.$store.commit('SET_ISVIDEO_DIALOG', false)
    },
    cancel() {
      // refuse
      this.socketSend('refuse')
      uni.$store.commit('SET_ISVIDEO_DIALOG', false)
    },
    join() {
      // console.log({
      //   ...this.data
      // })
      const nativeBridge = Vue.prototype.$nativeBridge
      this.socketSend('agree')
      nativeBridge.sendMessage(
        new NativeMessagePush({
          pageName: 'joinMeeting',
          params: {
            zoomMeetingId: this.data.meetingNumber,
            userName: this.data.username,
            isAutoAudioLink: 1
          }
        })
      )
      uni.$store.commit('SET_ISVIDEO_DIALOG', false)
    },
    toJoin() {
      createMeeting({
        multiPartyConsultationId: this.data.multiPartyConsultationId,
        doctorId: this.data.consultationDoctor.doctorID
      }).then(res => {
        const { code, codeDesc, data } = res
        if (code !== 0) {
          uni.showToast({
            title: codeDesc,
            icon: 'none'
          })
          return
        }
        // 创建会成功之后发送消息通知
        this.notice(data)
      })
    },
    //进入会议发送通知
    notice(data) {
      createMeetingRemind({
        multiPartyConsultationId: this.data.multiPartyConsultationId,
        doctorId: this.data.consultationDoctor.doctorID
      }).then(res => {
        let params = {
          action: 'sendmsg',
          touserid: this.data.applyDoctor.userID,
          userid: localStorage.getItem('USERID'),
          toplatform: 'web',

          message: JSON.stringify({
            action: 'videocall',
            userid: localStorage.getItem('USERID'),
            username: this.data.applyDoctor.doctorName,
            callstatus: 'call',
            platform: 'web',
            meetingNumber: data.meetingNumber,
            touserid: this.data.applyDoctor.userID
          })
        }
        // 消息通知成功之后发送socket
        uni.$socket.send(params)
        this.isSend = true
        this.data.isFive = false
      })
    },
    toCancel() {
      uni.$store.commit('SET_ISVIDEO_DIALOG', false)
    },
    // touserid 回复的时候永远是自己
    socketSend(callstatus) {
      let params = {
        action: 'sendmsg',
        touserid: this.data.userid,
        userid: localStorage.getItem('USERID'),
        toplatform: 'web',
        message: JSON.stringify({
          action: 'videocall',
          userid: localStorage.getItem('USERID'),
          username: this.data.applyDoctor.doctorName,
          callstatus: callstatus,
          videocallreturn: callstatus,
          platform: 'web',
          meetingNumber: this.data.meetingNumber,
          touserid: localStorage.getItem('USERID')
        })
      }
      console.log(params, '拒绝消息')
      // 消息通知成功之后发送socket
      uni.$socket.send(params)
    }
  }
}
</script>

<style lang="scss" scoped>
.video-dialog {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 12001;
  background: rgba(0, 0, 0, 0.6);
}

.popup-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;

  width: 12.8rem;
  border-radius: 0.682667rem;

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 3.2rem;
    background: linear-gradient(180deg, #1e68ff 0%, #71b9ff 100%);
    border-radius: 0.682667rem 0.682667rem 0 0;

    .title {
      font-size: 0.597333rem;
      color: #f2f8fe;
    }

    .time {
      font-weight: 600;
      font-size: 0.768rem;
      color: #ffffff;
    }
  }

  .warper {
    width: 100%;
    background: linear-gradient(180deg, #dbebff 4%, #edf4ff 100%);
    padding: 0.682667rem 0.426667rem 0 0.426667rem;
    border-radius: 0.682667rem;
    box-sizing: border-box;
    margin-top: -0.426667rem;

    .patient {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 1.024rem;
      line-height: 1.024rem;
      text-align: center;
      background: rgba(255, 255, 255, 0.45);
      border: 0.021333rem solid rgba(255, 255, 255, 0.25);
      border-radius: 0.682667rem;

      > text {
        font-size: 0.597333rem;
        color: #338ef7;
      }

      .patient-text {
        font-weight: 600;
        font-size: 0.597333rem;
        color: #338ef7;

        > text {
          margin: 0 0.170667rem;
        }
      }
    }

    .doctor {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 0.256rem;

      .left-icon {
        position: absolute;
        top: -0.853333rem;
        left: -1.386667rem;
        width: 2.282667rem;
        height: 12.8rem;
      }

      .right-icon {
        position: absolute;
        top: -0.426667rem;
        right: -1.386667rem;
        width: 2.282667rem;
        height: 12.8rem;
      }

      .photo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 5.546667rem;
        height: 5.546667rem;
        background: url('~@funcPuzzle/remote_collaborative_clinic_app/txbj.png') no-repeat
          center/cover;

        > image {
          width: 5.12rem;
          height: 5.12rem;
          border-radius: 100%;
        }
      }

      .patient-text {
        margin-top: 1.578667rem;
        font-weight: 500;
        font-size: 0.853333rem;
        color: #323843;

        > text {
          margin: 0 0.341333rem;
        }
      }

      .desc {
        margin-top: 0.426667rem;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 0.426667rem;

      .join {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8.533333rem;
        height: 1.877333rem;
        background: #0072f5;
        box-shadow: 0rem 0.085333rem 0.213333rem 0rem rgba(165, 205, 255, 0.65);
        border-radius: 0.512rem;
        font-size: 0.682667rem;
        color: #ffffff;
      }

      .cancel {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 8.533333rem;
        height: 1.877333rem;

        font-size: 0.682667rem;
        color: #0072f5;
      }
    }
  }

  .close-icon {
    position: absolute;
    bottom: -1.28rem;
    width: 1.066667rem;
    height: 1.066667rem;
  }
}
</style>
